import React, { useState } from 'react'
import { isEmpty } from 'lodash'
import styled from '@emotion/styled'

import { Table as AntTable, Empty } from 'antd'
import { Icon } from '@ant-design/compatible'
import { colors } from 'Utils';
import { Spinner } from 'Components'
import { Pagination } from 'antd'

export const ObjectivesAdminSummary = ({
  customList,
  firstCol,
  isLoaded
}) => {

  const [currentObjectives, setCurrentObjectives] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handleObjectivesChange = (page, pageSize) => {
    setCurrentObjectives(page);
    setPageSize(pageSize);
  }

  const getColumns = (lengthDatos) => {
    const base = [
      {
        dataIndex: "codigoDistribuidor",
        key: "codigoDistribuidor",
        ellipsis: true,
        render: (value, row, index) => {
          const obj = {
            children: value,
            props: {
              style: {
                background: "#C5E1F5",
                fontSize: "14px"
              },
              rowSpan: index === 0 ? lengthDatos : 0,
            },
          };
          return obj;
        },
      },
      {
        dataIndex: "nombreDistribuidor",
        key: "nombreDistribuidor",
        ellipsis: true,
        render: (value, row, index) => {
          const obj = {
            children: value,
            props: {
              style: { background: "#F7D2C4", fontSize: "14px" },
              rowSpan: index === 0 ? lengthDatos : 0,
            },
          };
          return obj;
        },
      },
      {
        dataIndex: "nombreObjetivo",
        key: "objetivoMaster",
        ellipsis: true,
        render: (value, row, index) => {
          const obj = {
            children: value,
            props: {
              style: { background: "#D4EFDF", fontSize: "14px" },
              rowSpan: index === 0 ? lengthDatos : 0,
            },
          };
          return obj;
        },
      },
      {
        title: 'Por equipo',
        dataIndex: 'porEquipo',
        key: 'porEquipo',
        align: 'center',
        className: 'row-xs-header',
        render: (value) => {
          const obj = {
            children: value,
            props: {
              class: 'row-xs-body'
            },
          };
          return obj;
        },
      },
      {
        title: 'Nivel',
        dataIndex: 'nivel',
        key: 'nivel',
        align: 'center',
        className: 'row-xs-header',
        render: (value) => {
          const obj = {
            children: value,
            props: {
              class: 'row-xs-body'
            },
          };
          return obj;
        },
      },
      {
        title: firstCol[1].text,
        dataIndex: "comercialHesa",
        key: "comercialHesa",
        ellipsis: true,
      },
      {
        title: 'Tipo de Objetivo',
        dataIndex: 'tipoObjetivo',
        key: 'tipoObjetivo',
        align: 'center',
        className: 'row-s-header',
        render: (value) => {
          const obj = {
            children: value,
            props: {
              class: 'row-s-body',
            },
          };
          return obj;
        },
      },
      {
        title: 'Fecha Periodo',
        dataIndex: 'fechaPeriodo',
        key: 'fechaPeriodo',
        align: 'center',
        className: 'row-l-header',
        render: (value) => {
          const obj = {
            children: value,
            props: {
              class: 'row-l-body'
            },
          };
          return obj;
        },
      },
      {
        title: 'Cantidad Objetivo',
        dataIndex: 'cantidadObjetivo',
        key: 'cantidadObjetivo',
        align: 'center',
        render: (value) => {
          return (
            <Cell negative={parseInt(value) < 0}>
              {value}
            </Cell>
          );
        },
      },
      {
        title: 'Cantidad Actual',
        dataIndex: 'cantidadActual',
        key: 'cantidadActual',
        align: 'center',
        render: (value) => {
          return (
            <Cell negative={parseInt(value) < 0}>
              {value}
            </Cell>
          );
        },
      },
    ]

    const notHesa = [
      {
        title: '% Cumplimiento',
        dataIndex: 'cumplimiento',
        key: 'cumplimiento',
        align: 'center',
        className: 'row-s-header',
        render: (value) => {
          const obj = {
            children: (
              <Cell negative={value !== '-' && parseInt(value) < 0}>
                {value}%
              </Cell>
            ),
            props: {
              class: 'row-s-body'
            },
          };
          return obj;
        },
      },
      {
        title: 'Incentivo Teórico',
        dataIndex: 'incentivoTeorico',
        key: 'incentivoTeorico',
        align: 'center',
        render: (value) => {
          return (
            <Cell negative={parseInt(value) < 0}>
              {value}
            </Cell>
          );
        },
      },
      {
        title: 'Incentivo Real',
        dataIndex: 'incentivoReal',
        key: 'incentivoReal',
        align: 'center',
        render: (value) => {
          return (
            <Cell negative={parseInt(value) < 0}>
              {value}
            </Cell>
          );
        },
      },
      {
        title: '% Incentivo',
        dataIndex: 'incentivo',
        key: 'incentivo',
        align: 'center',
        className: 'row-s-header',
        render: (value) => {
          const obj = {
            children: (
              <Cell negative={parseInt(value) < 0}>
                {value}%
              </Cell>
            ),
            props: {
              class: 'row-s-body'
            },
          };
          return obj;
        },
      },
    ]

    const estado = [
      {
        title: 'Estado',
        dataIndex: 'estado',
        key: 'estado',
        align: 'center',
        className: 'row-xs-header',
        render: (value) => {
          const stateColor = value === 'VENCIDO' ? '#7D7D7D' : '#54AC29';
          const obj = {
            children: (
              <span>
                <Icon type="clock-circle" style={{ color: stateColor, fontSize: '17px' }} theme="filled" />
              </span>
            ),
            props: {
              class: 'row-xs-body'
            },
          };
          return obj;
        },
      },
    ];

    return [...base, ...notHesa, ...estado]
  }

  return (
    <>
      <br />
      {(!isEmpty(customList) && customList.length > 1 && !isLoaded) && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
          <span style = {{marginRight: 10 }}>
            Bloques de objetivos: {currentObjectives === 1 ? `1-${pageSize}` : `${(currentObjectives - 1) * pageSize + 1}-${(currentObjectives * pageSize) < customList.length? currentObjectives * pageSize : customList.length}`} / {customList.length}
          </span>
          <Pagination
            current={currentObjectives}
            total={customList.length}
            onChange={handleObjectivesChange}
            pageSize={pageSize}
            showSizeChanger
            pageSizeOptions={['5', '10', '20']}
          />
        </div>
      )}
      {(!isEmpty(customList) && customList.length > 0 && !isLoaded) && (
      <StyledTableHeaderOnly
        rowKey="fakeHeader"
        size="small"
        dataSource={[]} // Sin datos
        pagination={false}
        columns={getColumns(1)} // Pasamos 1 para que renderice
        locale={{ emptyText: '' }} 
        showHeader={true}
        style={{
          marginBottom: 0,
          position: 'sticky',
          top: 0,
          zIndex: 5,
          background: '#fff',
          pointerEvents: 'none'
        }}
      />
    )}

      {customList.slice((currentObjectives - 1) * pageSize, currentObjectives * pageSize).map((objList, index) =>
        <StyledTable
          rowKey="idObj"
          showHeader={false}
          style={{ borderWidth: '0px', marginBottom: '-1px' }}
          // showHeader={index === 0}
          size={"small"}
          dataSource={objList.datos}
          pagination={false}
          columns={getColumns(objList.datos.length)}
        />
      )}
      {(isEmpty(customList) && !isLoaded) && (
        <NoData description={`No hay objetivos para mostrar`} />
      )}
      {isLoaded && <Spinner />}
    </>
  )
}



const StyledTable = styled(AntTable)(({ cursor }) => ({
  cursor: cursor ? 'pointer' : 'initial',
  boxShadow: '4px 4px 5px 0px rgba(150,150,150,1)',

  '& .ant-table-thead': {
    position: 'sticky',
    top: 0,
    zIndex: 2,
    background: '#fff',
  },
  '& .ant-table-thead > tr > th': {
    textAlign: 'center',
    fontSize: 14,
    fontWeight: 600,
    color: '#205527',
  },
  '& .ant-table-small > .ant-table-content > .ant-table-body': {
    margin: '0px',
    fontSize: '13px',
  },
  '& .ant-table-tbody > tr > td': {
    textAlign: 'center',
    background: '#F3FAF3',
    borderTop: '1px solid darkGray',
    borderBottom: 'none'
  },
  '& th.row-l-header.ant-table-align-center': {
    width: '130px !important',
  },
  '& td.row-l-body': {
    width: '130px !important',
  },
  '& th.row-s-header.ant-table-align-center': {
    width: '100px !important',
  },
  '& td.row-s-body': {
    width: '100px !important',
  },
  '& th.row-xs-header.ant-table-align-center': {
    width: '70px !important',
  },
  '& td.row-xs-body': {
    width: '70px !important',
  },
  '& .ant-table-row-cell-ellipsis': {
    width: '130px !Important',
  },
}))

const StyledTableHeaderOnly = styled(StyledTable)`
  .ant-table-placeholder {
    display: none;
  }

  .ant-table-tbody {
    display: none;
  }

  pointer-events: none; // Evita interacción
`

const NoData = styled(Empty)`
  margin: 50px;
  font-size: 24px;
  color: ${colors.whiteTwo};
`
const Cell = styled.span`
  color: ${props => (props.negative ? 'rgba(255,0,0,.6)' : 'rgba(0,0,0,.6)')};
`